import { createEvent, createStore } from "effector";
import { ModuleDescription, ModelContract } from "@features/shared/module-description";

export function createInteractivePromptUIModel() {
    const dropdownOpenChanged = createEvent<boolean>();
    const promptExpandedToggled = createEvent();
    const tryButtonClicked = createEvent();

    const $isAnyDropdownOpen = createStore<boolean>(false).on(dropdownOpenChanged, (_, isOpen) => isOpen);
    const $isPromptExpanded = createStore<boolean>(false).on(promptExpandedToggled, (state) => !state);

    return new ModelContract(
        {
            $isAnyDropdownOpen,
            $isPromptExpanded
        },
        {
            dropdownOpenChanged,
            promptExpandedToggled,
            tryButtonClicked
        },
        {},
        {}
    );
}

export class InteractivePromptUIModule extends ModuleDescription<
    ModelContract<
        {
            $isAnyDropdownOpen: any;
            $isPromptExpanded: any;
        },
        any,
        any,
        any
    >
> {
    private _defaultContract: ModelContract<any, any, any, any> | null = null;

    constructor() {
        super();
    }

    createInstance() {
        return createInteractivePromptUIModel();
    }

    getDefaultContract() {
        if (!this._defaultContract) {
            this._defaultContract = createInteractivePromptUIModel();
        }
        return this._defaultContract;
    }

    run() {}
}
